import React from 'react'
import { useContext } from 'react'
import { MenuContext } from '../context'
import Title from '../components/Title'
import { MdSearch } from "react-icons/md";

// get all unique values
const getUnique = (items, value) => {
    return [...new Set(items.map(item => item[value]))].sort();
}

export default function MenuFilter({ menu }) {
    const context = useContext(MenuContext);

    const {
        handleChange, type, portion, price, minPrice, maxPrice, glutenFree, vegeterian
    } = context;

    // get unique types
    let types = getUnique(menu, 'type');

    let people = getUnique(menu, 'portion');

    // add all
    types = ['All', ...types];


    // map to jsx
    types = types.map((item, index) => {
        return <option value={item} key={index}>{item}</option>
    });
    people = people.map((item, index) => {
        return <option value={item} key={index}>{item}</option>
    });

    return (
        <section className="filter-container">
            <Title title="search menu" />
            {/* Search Menu */}
            <div className="search-container">
                <div>
                    <i><MdSearch size={28} style={{ position: 'absolute', paddingTop: 7 }} /></i>
                    <input name="search" placeholder="Search" type="text" onChange={handleChange} />
                </div>
            </div>
            <form className="filter-form">

                {/* Menu Type */}
                <div className="select-container">
                    <label htmlFor="type">Menu type</label>
                    <select name="type" className="form-control" id="type" value={type} onChange={handleChange}>
                        {types}
                    </select>
                </div>

                {/* Portion Type */}
                <div className="select-container">
                    <label htmlFor="portion">Portion</label>
                    <select name="portion" className="form-control" id="portion" value={portion} onChange={handleChange}>
                        {people}
                    </select>
                </div>

                {/* Menu Price */}
                <div className="form-group">
                    <label htmlFor="price">menu price ${price}</label>
                    <input className="price-slider" type="range" name="price" min={minPrice} max={maxPrice} id="price" value={price} onChange={handleChange} />
                </div>

                {/* Extras */}
                <div className="checkBox-container">
                    <div className="single-extra">
                        <label htmlFor="vegeterian">vegeterian</label>
                        <input type="checkbox" name="vegeterian" id="vegeterian" checked={vegeterian} onChange={handleChange} />
                    </div>

                    <div className="single-extra">
                        <label htmlFor="glutenFree">gluten free</label>
                        <input type="checkbox" name="glutenFree" id="glutenFree" checked={glutenFree} onChange={handleChange} />
                    </div>

                </div>

                {/* end Extras */}
            </form>
        </section >
    );
}
